import {RegularExp} from "../consts/consts";
import {commonEventEmitter} from "../../commonEventEmitter";

export default class Abstract {
  _captcha = {
    token: null,
    type: null,
  };

  constructor(loginContainer, formSelector) {
    this._loginContainer = loginContainer;
    this._form = this._loginContainer.querySelector(formSelector);

    this._callback = {};

    this._eventEmitter = commonEventEmitter;

    this._inputsElements = this._form.querySelectorAll(`input`);

    this._watchFormSubmit = this._watchFormSubmit.bind(this);

    this._processingServerResponse = this._processingServerResponse.bind(this);
  }

  _validateInput(type) {
    const input = Array.from(this._inputsElements).find((element) => element.dataset.type === type);

    if (type === `email`) {
      return input.value.match(RegularExp.EMAIL) !== null;
    }

    if (type === `tel`) {
      return input.value.match(RegularExp.PHONE) !== null;
    }

    if (type === `code`) {
      return input.value.match(RegularExp.PIN) !== null;
    }

    if (type === `password`) {
      return input.value.length > 1;
    }
  }

  changeFormSubmitStatus(evt) {
    evt.preventDefault();

    if (!this._captcha.token) {
      if (!window.smartCaptcha) {
        return;
      }

      console.log(1);

      commonEventEmitter.emit(`captcha.set-type`, this._captcha.type);
      window.smartCaptcha.execute();
      return;
    }
  }

  _processingServerResponse(data) {
    commonEventEmitter.emit(`captcha.remove`);
  }

  _watchFormSubmit(evt) {
    this._callback.formSubmit(evt);
  }

  setFormSubmitHandler(callback) {
    this._callback.formSubmit = callback;
    this._form.addEventListener(`submit`, this._watchFormSubmit);
  }
}
